import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { Theme } from './LandingNav';

const THEME_KEY = 'hyvay:landing-theme';

function readTheme(): Theme {
    try {
        const v = localStorage.getItem(THEME_KEY);
        if (v === 'dark' || v === 'light') return v;
    } catch { /* storage unavailable */ }
    return 'light';
}

/** The landing's light/dark switch, shared by every page that wears the landing chrome. */
export function useLandingTheme(): [Theme, () => void] {
    const [theme, setTheme] = useState<Theme>(readTheme);
    const toggle = () => setTheme((t) => {
        const next = t === 'light' ? 'dark' : 'light';
        try { localStorage.setItem(THEME_KEY, next); } catch { /* ignore */ }
        return next;
    });
    return [theme, toggle];
}

/**
 * Props for a link to the template catalog (/templates), navigated in-app;
 * modifier clicks (new tab) keep the browser's default.
 */
export function useTemplatesLink(): { href: string; onClick: (e: React.MouseEvent<HTMLAnchorElement>) => void } {
    const navigate = useNavigate();
    return {
        href: '/templates',
        onClick: (e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
            e.preventDefault();
            navigate('/templates');
        },
    };
}
